import React, { useState } from "react";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import ContactsTable from "./DialSessionsContactTable/DialSessionContactsTableV3";

function ViewContactsModal({
  dialSessionId,
  contactCount,
  btnColor = null,
  btnText,
  btnClass,
  icon = null,
  iconColor,
  modalHeader,
  isTotal = false,
  isUrgent = false,
  isCallable = false,
  disabled = false,
}) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(true);

  const handleClose = () => setModalOpen(false);

  return (
    <div>
      <Button
        basic={isTotal}
        size="tiny"
        className={btnClass}
        color={btnColor}
        disabled={disabled}
        onClick={handleOpen}
      >
        <span className="contacts-count">
          {contactCount} {btnText}
        </span>
        {icon ? <Icon name={icon} /> : null}
      </Button>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        closeOnDimmerClick={false}
        size="large"
        closeIcon
      >
        <Header content={modalHeader} />
        <Modal.Content>
          <div className="tw:flex tw:h-[480px] tw:w-full tw:flex-col tw:overflow-y-auto">
            <ContactsTable
              dialSessionId={dialSessionId}
              total={isTotal}
              isUrgent={isUrgent}
              isCallable={isCallable}
            />
          </div>
        </Modal.Content>
      </Modal>
    </div>
  );
}

export { ViewContactsModal };
